// let {BrowserRouter,Switch,Route,NavLink} = ReactRouterDOM;
// import {BrowserRouter as Router, Switch, Route, NavLink} from "react-router-dom";
import React from "react";

import {
  BrowserRouter as Router,
  NavLink,
  Link,
  useHistory,
} from "react-router-dom";
import { useEffect, useState } from "react";
import "../schoolAdminPortal/schoolAdmin.css";
import schoolAdminLogo from "../../assets/images/schoolAdminLogo.png";
import IconButton from "@material-ui/core/IconButton";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import wifi from "../../assets/images/wifi.png";
import rending from "../../assets/images/rending.png";
import featured from "../../assets/images/featured.png";
import groups from "../../assets/images/groups.png";
import vidoliabrary from "../../assets/images/vidoliabrary.svg";
import schoolDashboard from "../../assets/images/schoolDashboard.png";
import setting from "../../assets/images/setting.png";
import scoaches from "../../assets/images/scoaches.png";
import Sathelete from "../../assets/images/Sathelete.png";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import userService from "../../services/user.service";

import {
  getFromLocalStorage,
  removeFromLocalStorage,
  setInToLocalStorage,
} from "../../utils/webStorage";
import { setDrawerOpen } from "../../Redux/Actions/SchoolAdminDashboardAction";
import { useDispatch, useSelector } from "react-redux";
import ProfileSection from "./ProfileSection";

const menuId = "primary-search-account-menu";

const textProfile = {
  color: "black",
  textAlign: "right",
};

function MobileNavbar(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [UserName, setUserName] = useState(null);
  const [adminRole, setadminRole] = useState(null);
  const [schoolName, setschoolName] = useState(null);
  const [schoolId, setSchoolId] = useState(null);
  const [click, setClick] = React.useState(false);
  const [billingMsgFlag, showBillingMsgFlag] = useState(false);
  const [coachId, setCoachId] = useState(null);
  const [shortBilingMsg, setShortBilingMsg] = useState("");
  const [showBillingMsg, setShowBillingMsg] = useState("");
  const [msgCount, setCountMsgShow] = useState(0);
  const [loginLogo, setLoginLogo] = useState("");
  const [schoolLogoShow, setschoolLogoShow] = useState(null);
  const [isOpen, setIsOpen] = useState(true);
  const [openReset, setOpenReset] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const dispatch = useDispatch();
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );

  const handleClickSucess = () => {
    setOpenSuccess(true);
    setOpenReset(false);
  };

  const handleClickCloseSucess = () => {
    setOpenSuccess(false);
  };

  const handleClickToOpenReset = () => {
    setOpenReset(true);
  };

  const handleToCloseReset = () => {
    setOpenReset(false);
  };

  useEffect(() => {
    let adminRole = getFromLocalStorage("loginRole");
    setadminRole(adminRole);
  }, []);

  const handleClick = () => setClick(!click);
  const Close = () => setClick(false);
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    let UserName = getFromLocalStorage("loginUser");
    let adminRole = getFromLocalStorage("loginRole");
    let schoolName = getFromLocalStorage("schoolName");
    let schoolLogoShow = getFromLocalStorage("schoolLogo");

    let coachId = getFromLocalStorage("coachId");
    let schoolId = getFromLocalStorage("schoolId");
    let loginUserProfile = getFromLocalStorage("loginUserProfile");

    setUserName(UserName);
    setadminRole(adminRole);
    setschoolName(schoolName);
    setschoolLogoShow(schoolLogoShow);
    setCoachId(coachId);
    setSchoolId(schoolId);
    setLoginLogo(loginUserProfile);
  }, []);

  const currentRoute = useHistory().location.pathname.toLowerCase();

  const history = useHistory();

  const isMenuOpen = Boolean(anchorEl);

  const getLiveDueDates = (schoolId) => {
    userService
      .getBillingDetailsCheck(schoolId)
      .then((response) => {
        let msgCount1 = getFromLocalStorage("billingShowHideFlag");
        if (msgCount1 === "true") {
          let msgCount1 = getFromLocalStorage("billingShowHideFlag");
        } else {
          if (response.data.data !== "") {
            setShowBillingMsg(response.data.data.split(","));
            setShortBilingMsg(response.data.data.split(","));
            showBillingMsgFlag(true);
            setCountMsgShow(1);
            setInToLocalStorage("billingShowHideFlag", true);
          }
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  function logout() {
    removeFromLocalStorage("user");
    window.localStorage.clear();
    history.push("/login");
  }

  const toggleDrawer = () => {
    setDrawerOpen(dispatch, !isDrawerOpen);
  };
  return (
    <div id="mobileNavbar" style={{ minHeight: "64px" }}>
      <div className={click ? "main-container" : ""} onClick={() => Close()} />
      <nav className="navbar" onClick={(e) => e.stopPropagation()}>
        <div className="nav-container">
          <IconButton aria-label="open drawer" onClick={toggleDrawer}>
            <MenuIcon />
          </IconButton>
          <ProfileSection />
        </div>
      </nav>
    </div>
  );
}

export default MobileNavbar;
